function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 188.817,
  cy: 188.813,
  r: 187.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188.817,
  cy: 188.813,
  r: 185.417,
  stroke: "#3c00dc",
  strokeWidth: 4.17
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.815,
  cy: 186.729,
  r: 4.159,
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 8.33,
  strokeLinejoin: "round",
  strokeMiterlimit: 2
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 297.15,
  cy: 84.646,
  r: 8.333
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.15,
  cy: 84.646,
  r: 6.25,
  stroke: "#3c00dc",
  strokeWidth: 4.17
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M190.9 186.729l100-95.833M190.9 190.896l62.5 112.5",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 188.817,
  cy: 188.813,
  r: 154.167
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188.817,
  cy: 188.813,
  r: 152.083,
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4.17,237.5"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M72.141 91.46S146.797-1.014 260.64 53.915M335.284 148.925s37.337 109.709-78.318 175.606",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.5
});

function SvgClockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 378 378",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgClockinline;